// extracted by mini-css-extract-plugin
export default {"content":"BE_sWm"};